// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2vld0","productName":"Table_productName__KBjP_"};